import React from 'react';
import { Typography, Divider, FormControl, InputLabel, Select, MenuItem, Box } from "@mui/material";
import Grid from '@mui/material/Grid';
import WarningIcon from "@mui/icons-material/Warning";
import moment from 'moment-timezone';
import { DATE_FORMAT_IN_READABLE_FORMAT } from '../../config/DateTimeConstants';

export default function DisplayRebookingDetails({ showTimeslots, selectedChildName, currentServiceType, contentName, availableTimeslots, selectedTimeslot, setSelectedTimeslot }) {

  const headerLabelStyle = { fontWeight: 'bold', mt: 2, mb: 1 };
  const valueStyle = { mt: 2, mb: 1 }

  const displaySelectTimeslotDropdown = () => {
    return <FormControl sx={{ width: '250px' }}>
      <InputLabel id="availableTimeslots">Timeslots</InputLabel>

      <Select id="timeslot" labelId="timeslot" label="Timeslot" onChange={(e) => setSelectedTimeslot(e.target.value)} value={selectedTimeslot} >
        {availableTimeslots.map(timeslot => (
          <MenuItem key={timeslot} value={timeslot}>
            {moment(timeslot).format(DATE_FORMAT_IN_READABLE_FORMAT)}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  }

  const displayNoTimeslotAvailableMessage = () => {
    return <Typography variant="body1" sx={valueStyle}>
      <WarningIcon
        fontSize="small"
        style={{ fill: "orange", font: "inherit", position: "relative", verticalAlign: "middle", marginRight: "0.5rem" }}
      />
      No upcoming timeslots found for this content
    </Typography>
  }

  return (
    <Grid container spacing={0.5}>

      <Grid size={3}>
        <Typography variant="body1" sx={headerLabelStyle}>Child:</Typography>
      </Grid>

      <Grid size={8}>
        <Typography variant="body1" sx={valueStyle}>{selectedChildName}</Typography>
      </Grid>

      <Grid size={3}>
        <Typography variant="body1" sx={headerLabelStyle}>Service Type:</Typography>
      </Grid>

      <Grid size={3}>
        <Typography variant="body1" sx={valueStyle}>{currentServiceType}</Typography>
      </Grid>

      <Grid size={2}>
        <Typography variant="body1" sx={headerLabelStyle}>Content:</Typography>
      </Grid>

      <Grid size={4}>
        {contentName.map((name, index) => (
          <Typography key={index} variant="body1" sx={valueStyle}>{name}</Typography>
        ))}
      </Grid>

      {showTimeslots && (
        <>
          <Grid size={12}>
            <Divider sx={{ my: 2 }} />
          </Grid>

          <Grid size={3}>
            <Typography variant="body1" sx={headerLabelStyle}>
              Select Timeslot:
            </Typography>
          </Grid>

          <Grid size={6}>
            {availableTimeslots.length > 0 ? displaySelectTimeslotDropdown() : displayNoTimeslotAvailableMessage()}
          </Grid>
        </>
      )}

      {!showTimeslots && (
        <Grid size={12} sx={{ my: 4 }}>
          <Box height="32px" />
        </Grid>
      )}
    </Grid >
  );
}
